/*==========================================================
INITIALIZE INTERIOR SCRIPT
==========================================================*/
// PHOTO GALLERY
//$(function() {
//    $(".eSolutionsGroupPhotoGalleryV2PlaceholderDiv").each(function () {
//        var method = $(this).attr("method");
//        var id = $(this).attr("id");
//        if (id != '') {
//            $(this).load(id, function () {
//                $(this).find(".prev.keyboardnav").attr("aria-label", iCreateObject.languageResources["AriaLabel_Modules_PhotoGallery_PreviousArrow"]);
//                $(this).find(".next.keyboardnav").attr("aria-label", iCreateObject.languageResources["AriaLabel_Modules_PhotoGallery_NextArrow"]);
//                $(this).find(".pause.keyboardnav").attr("aria-label", iCreateObject.languageResources["AriaLabel_Modules_PhotoGallery_Pause"]);
//                $(this).find(".pause.paused.keyboardnav").attr("aria-label", iCreateObject.languageResources["AriaLabel_Modules_PhotoGallery_Play"]);
//                $(this).find(".pause.keyboardnav").on('click', function (e) {
//                    if ($(e.target).hasClass("paused")) {
//                        $(e.target).attr("aria-label", iCreateObject.languageResources["AriaLabel_Modules_PhotoGallery_Pause"]);
//                    } else {
//                        $(e.target).attr("aria-label", iCreateObject.languageResources["AriaLabel_Modules_PhotoGallery_Play"]);
//                    }
//                });
//                return method;
//            });
//        } else {
//            $(this).html('');
//        }
//    });
//});

$(function () {
    if (!iCreateObject.isSiteInICreateMode) {
        $('#ShareItemsPlaceholder li').last().addClass('last');
    }
    else {
        $('#ShareItemsPlaceholder').empty();
    }

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        $('#Share a.ShareLink').click(function (e) {
            if (isSiteinICreateMode()) {
                showNAMessage();
            } else {
                e.preventDefault();
                $('#Share').trigger('mouseenter');
            }
        });
    }

    //override the share links to current URL
    var curpage = encodeURIComponent(window.location);
    var curPageHeading = $(document).find('h1').length ? $.trim($('h1').text()).replace(/\s\s+/g, ' ') : $.trim($(document).find('title').text());
    $('#fbShare').attr('href', 'https://www.facebook.com/sharer.php?u=' + curpage);
    $('#liShare').attr('href', 'https://www.linkedin.com/shareArticle?mini=true&url=' + curpage);
    $('#twShare').attr('href', 'https://www.twitter.com/intent/tweet?text=Check+out+ ' + curPageHeading + ' ' + curpage);

});

//Scripts to wrap tables
if ((!iCreateObject.isSiteInICreateMode || iCreateObject.isSiteInPreviewMode) && !isFrontEndDev) {
    function icrt_table_resize() {
        var contentWidth = ($('#printAreaContent').width());
        $('#printAreaContent table').each(function (index,item) {
            var contentRow = $(item).closest('.fbg-row');
            if ((contentRow.length && $(this).width() > $(contentRow).width()) || $(this).width() > contentWidth) {
                if ($(this).parent('.tableContainer').length === 0) {
                    $(this).wrap('<div class="tableContainer" />');
                    var wideTable = $(this).addClass('wideTable');
                    var wideTableContainer = $(wideTable).parent();
                    $('<div class="tableContainerHead">' + iCreateObject.languageResources['Common_Includes_headInterior_TableScrollMessage'] + '</div>"').insertBefore(wideTableContainer);
                }
            } else if ((contentRow.length && $(this).width() <= $(contentRow).width()) || $(this).width() <= contentWidth) {
                if ($(this).parent('.tableContainer').length > 0) {
                    $(this).parent().siblings('.tableContainerHead').detach();
                    $(this).unwrap();
                    $(this).removeClass('wideTable');
                }
            }
        });
    }

    $(document).ready(function () {
        $('.AccordionTrigger').on('click', function () {
            icrt_table_resize();
        });
    });
    $(window).load(function () { setTimeout(function () { icrt_table_resize(); }, 0); });
    $(window).resize(function () { setTimeout(function () { icrt_table_resize(); }, 0); });
}
